import {Component, Inject, OnInit} from '@angular/core';
import {IoTreeNodeModel} from '../../modules/imaging/models/io-tree-node.model';
import {DocumentFolderDataModel} from '../../models/document/document-folder-data.model';
import {IoTreeNodeTypeModel} from '../../modules/imaging/models/io-tree-node-type.model';
import {FileManagerService} from '../../modules/file-manager/file-manager.service';
import {ITdoTreeItem} from '../../tdo-controls/common/tdo-tree/models/i-tdo-tree-item';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {
  PresentationFoldersConfigurationService
} from '../../modules/configuration/ui/presentation-folders-configuration/presentation-folders-configuration.service';
import {Globals} from '../../globals';
import {PresentationFoldersConfigurationModel} from '../../models/configuration/presentation-folders-configuration.model';





@Component({
  selector: 'app-folder-selection-dialog',
  templateUrl: './folder-selection-dialog.component.html',
  styleUrls: ['./folder-selection-dialog.component.scss']
})
export class FolderSelectionDialogComponent implements OnInit {

  FolderTreeData: IoTreeNodeModel[] = [];
  selectedFolderTreeNode: IoTreeNodeModel;
  libraryTreeData: IoTreeNodeModel[] = [];
  lectureTreeData: IoTreeNodeModel[] = [];
  selectedLibraryTreeNode: IoTreeNodeModel;
  selectedLectureTreeNode: IoTreeNodeModel;
  tableName: string;
  folderList: PresentationFoldersConfigurationModel[];
  selectedFolder: PresentationFoldersConfigurationModel;
  selectedTab = 0;
  isFolderPresentation = false;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any,
              public fileManagerService: FileManagerService,
              private globals: Globals,
              private presentationService: PresentationFoldersConfigurationService,
              public dialogRef: MatDialogRef<FolderSelectionDialogComponent>) {
    if (data.FromTable !== 'undefined') {
      this.tableName = data.FromTable;
    } else {
      this.tableName = '';
    }
  }

  ngOnInit(): void {
    this.init();
  }

  private async init() {
    if (this.tableName === 'FolderPresentation') {
      this.isFolderPresentation = true;
      this.presentationService.getPresentationFolders(this.globals.LOCID).subscribe(ddata => {
        console.log('getting folders ', ddata);
        this.folderList = [];
        this.FolderTreeData = [];
        this.folderList = ddata;
        this.selectedFolder = this.folderList[0];
        this.initFolderTree(ddata);
      }, err => {
        console.log(err);
      });
    } else {
      this.isFolderPresentation = false
      this.fileManagerService.getLibraryDocumentFolders().subscribe((res) => {
        this.initLibraryTree(res.LibraryFolders);
        this.initLectureTree(res.LectureFolders);
      });
    }
  }
  private initLibraryTree(folders: DocumentFolderDataModel[]): void {
    const treeNode = new IoTreeNodeModel();
    const rootNodeData = folders[0];
    treeNode.id = rootNodeData.DocumnetFolderId;
    treeNode.name = rootNodeData.FolderName;
    treeNode.type = IoTreeNodeTypeModel.Library;
    treeNode.isExpanded = true;
    this.libraryTreeData.push(treeNode);
    const nonRootFolders = folders.filter(p => p.DocumentFolderParentId !== null);

    for (const folder of nonRootFolders) {
      const childNode = new IoTreeNodeModel();
      childNode.id = folder.DocumnetFolderId;
      childNode.name = folder.FolderName;
      childNode.type = IoTreeNodeTypeModel.Library;
      childNode.isExpanded = true;

      if (folder.DocumentFolderParentId === treeNode.id) {
        treeNode.children.push(childNode);
      } else {
        const parent = this.sortFoldersIntoFolders(treeNode, folder);
        parent.children.push(childNode);
      }
    }
  }

  private initLectureTree(folders: DocumentFolderDataModel[]): void {
    const treeNode = new IoTreeNodeModel();
    const rootNodeData = folders[0];
    treeNode.id = rootNodeData.DocumnetFolderId;
    treeNode.name = rootNodeData.FolderName;
    treeNode.type = IoTreeNodeTypeModel.Lecture;
    treeNode.isExpanded = true;
    this.lectureTreeData.push(treeNode);
    const nonRootFolders = folders.filter(p => p.DocumentFolderParentId !== null);

    for (const folder of nonRootFolders) {
      const childNode = new IoTreeNodeModel();
      childNode.id = folder.DocumnetFolderId;
      childNode.name = folder.FolderName;
      childNode.type = IoTreeNodeTypeModel.Lecture;
      childNode.isExpanded = nonRootFolders.some(p => p.DocumentFolderParentId === folder.DocumnetFolderId);

      if (folder.DocumentFolderParentId === treeNode.id) {
        treeNode.children.push(childNode);
      } else {
        const parent = this.sortFoldersIntoFolders(treeNode, folder);
        parent.children.push(childNode);
      }
    }
  }
  sortFoldersIntoFolders(treeNode: IoTreeNodeModel, folder: DocumentFolderDataModel): IoTreeNodeModel {
    const node = treeNode.children.find(p => p.id === folder.DocumentFolderParentId);
    if (node) {
      return node;
    } else {
      for (const innerNode of treeNode.children) {
        const tmp = this.sortFoldersIntoFolders(innerNode, folder);
        if (tmp) {
          return tmp;
        }
      }
    }
  }

  onCancelClick() {
    this.dialogRef.close(null);
  }

  onOkClick() {
    if (this.tableName === 'FolderPresentation') {
      this.dialogRef.close(this.selectedFolderTreeNode);
    }
    else {
      this.dialogRef.close(this.selectedLibraryTreeNode);
    }
  }

  isFolderPresentationItemSelected(item: ITdoTreeItem): boolean {
    return item === this.selectedFolderTreeNode;
  }
  isItemSelected(item: ITdoTreeItem): boolean {
    return item === this.selectedLibraryTreeNode;
  }

  isLectureItemSelected(item: ITdoTreeItem): boolean {
    return item === this.selectedLectureTreeNode;
  }

  onLibraryTreeItemSelected(item: ITdoTreeItem) {
    item.isExpanded = item.children && item.children.length > 0;
    if (this.selectedLibraryTreeNode === item) {
      return;
    }
    this.selectedLibraryTreeNode = item as IoTreeNodeModel;
  }

  onLibraryTreeContext($event: MouseEvent, item: any) {

  }

  onLectureTreeItemSelected(item: ITdoTreeItem) {
    item.isExpanded = item.children && item.children.length > 0;
    if (this.selectedLectureTreeNode === item) {
      return;
    }
    this.selectedLectureTreeNode = item as IoTreeNodeModel;

  }

  private initFolderTree(folders: PresentationFoldersConfigurationModel[]): void {
    let isFound = false;
    let rootNode: IoTreeNodeModel;
    const rootFolders = folders.filter(p => p.ParentFolderPresentationID == null);
    const nonRootFolders = folders.filter(p => p.ParentFolderPresentationID !== null);
    for (const root of rootFolders) {
      rootNode = new IoTreeNodeModel();
      const rootNodeData = root;
      rootNode.id = rootNodeData.FolderPresentationID;
      rootNode.name = rootNodeData.DisplayName;
      rootNode.type = IoTreeNodeTypeModel.Default;
      rootNode.isExpanded = nonRootFolders.some(p => p.ParentFolderPresentationID === rootNode.id);
      this.FolderTreeData.push(rootNode);

      for (const folder of nonRootFolders) {
        const childNode = new IoTreeNodeModel();
        childNode.id = folder.FolderPresentationID;
        childNode.name = folder.DisplayName;
        childNode.type = IoTreeNodeTypeModel.Default;
        childNode.isExpanded = nonRootFolders.some(p => p.ParentFolderPresentationID === folder.DocumnetFolderId);
        
        if (folder.ParentFolderPresentationID === rootNode.id) {
          rootNode.children.push(childNode);
          isFound = true;
        }
        else {
          const parent = this.sortFoldersIntoFoldersPresentation(rootNode, folder);
          if (parent) {
            parent.children.push(childNode);
          }
        }
      }
    }
  }

  sortFoldersIntoFoldersPresentation(treeNode: IoTreeNodeModel, folder: PresentationFoldersConfigurationModel): IoTreeNodeModel {
    const node = treeNode.children.find(p => p.id === folder.ParentFolderPresentationID);
    if (node) {
      return node;
    } else {
      for (const innerNode of treeNode.children) {
        const tmp = this.sortFoldersIntoFoldersPresentation(innerNode, folder);
        if (tmp) {
          return tmp;
        }
      }
    }
  }
  onFolderTreeItemSelected(item: ITdoTreeItem) {
    if (item.children.length > 0) {
      item.isExpanded = !item.isExpanded;
    } else {
      item.isExpanded = false;
    }
    if (this.selectedFolderTreeNode === item) {
      return;
    }
    this.selectedFolderTreeNode = item as IoTreeNodeModel;
    const selected = this.folderList.filter(p => p.FolderPresentationID === this.selectedFolderTreeNode.id);
    this.selectedFolder = selected[0];
  }

  onFolderTreeContext($event: MouseEvent, item: any) {

  }
}
